module.exports = __webpack_public_path__ + "static/media/desktop.a8e7cc33.png";